import React from "react";

const About = () => {
  const methodology = [
    { icon: "fa-search", label: "Discover" },
    { icon: "fa-pencil-ruler", label: "Design" },
    { icon: "fa-code", label: "Develop" },
    { icon: "fa-rocket", label: "Deploy" },
    { icon: "fa-chart-line", label: "Scale" },
  ];

  return (
    <section id="about" style={{ padding: "80px 0", backgroundColor: "white" }}>
      <div className="container">
        <div
          className="about-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "64px",
            alignItems: "center",
          }}
        >
          <div>
            <span style={{ color: "#1746A2", fontWeight: 500 }}>About Us</span>
            <h2
              style={{
                fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
                fontWeight: "bold",
                color: "#0C1A36",
                marginTop: "8px",
                marginBottom: "24px",
              }}
            >
              Who We Are
            </h2>
            <p
              style={{
                color: "#4b5563",
                fontSize: "18px",
                lineHeight: 1.8,
                marginBottom: "32px",
              }}
            >
              Ingenious Tech & Consulting Solutions partners with organisations
              to modernise processes and build scalable digital platforms. Our
              team blends process engineering, software craftsmanship and change
              management to deliver measurable outcomes.
            </p>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            >
              <div style={{ display: "flex", gap: "16px" }}>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    backgroundColor: "rgba(23, 70, 162, 0.1)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <i
                    className="fas fa-bullseye"
                    style={{ fontSize: "20px", color: "#1746A2" }}
                  ></i>
                </div>
                <div>
                  <h3
                    style={{
                      fontWeight: "bold",
                      color: "#0C1A36",
                      marginBottom: "4px",
                    }}
                  >
                    Our Mission
                  </h3>
                  <p style={{ color: "#4b5563" }}>
                    To empower businesses through intelligent digital solutions
                    that unlock efficiency and improve performance.
                  </p>
                </div>
              </div>
              <div style={{ display: "flex", gap: "16px" }}>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    backgroundColor: "rgba(23, 70, 162, 0.1)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <i
                    className="fas fa-eye"
                    style={{ fontSize: "20px", color: "#1746A2" }}
                  ></i>
                </div>
                <div>
                  <h3
                    style={{
                      fontWeight: "bold",
                      color: "#0C1A36",
                      marginBottom: "4px",
                    }}
                  >
                    Our Vision
                  </h3>
                  <p style={{ color: "#4b5563" }}>
                    To become Africa's leading innovation and automation
                    consultancy—transforming industries through world-class
                    execution.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#f9fafb",
              borderRadius: "16px",
              padding: "32px",
            }}
          >
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#0C1A36",
                marginBottom: "32px",
                textAlign: "center",
              }}
            >
              Our Methodology
            </h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
                gap: "16px",
              }}
            >
              {methodology.map((step, index) => (
                <div key={index} style={{ textAlign: "center" }}>
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      backgroundColor: "#1746A2",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 12px",
                    }}
                  >
                    <i
                      className={`fas ${step.icon}`}
                      style={{ fontSize: "20px", color: "white" }}
                    ></i>
                  </div>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#0C1A36",
                      fontSize: "14px",
                    }}
                  >
                    {step.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
                @media (min-width: 1024px) {
                    .about-grid { grid-template-columns: 1fr 1fr !important; }
                }
            `}</style>
    </section>
  );
};

export default About;
